import {
  getDepartmentNamesArray,
  getItemOrDefaultToValue,
} from '../../details';
import { intervalMapping } from 'utils/constants/patrolSchedule';

export const transform = (list, globalDepartmentList = []) => {
  return list.map(data => ({
    id: data.id,
    archived: data.archived,
    businessClientName: getItemOrDefaultToValue(
      data.businessClient,
      'businessClientName',
      '-',
    ),
    securityCompanyId: getItemOrDefaultToValue(data, 'securityCompanyId'),
    securityCompanyName: getItemOrDefaultToValue(data, 'securityCompanyName'),
    siteId: getItemOrDefaultToValue(data.site, 'siteId', '-'),
    siteName: getItemOrDefaultToValue(data.site, 'siteName', '-'),
    patrolName: getItemOrDefaultToValue(data, 'definitionName', '-'),
    frequency:
      intervalMapping[getItemOrDefaultToValue(data.schedule, 'interval', '-')],
    checkpoints: getItemOrDefaultToValue(data, 'numCheckpoints', 0),
    isMultiSite: getItemOrDefaultToValue(data, 'isMultiSite', false),
    businessClient: getItemOrDefaultToValue(data, 'businessClient'),
    site: getItemOrDefaultToValue(data, 'site'),
    departments:
      data?.departmentIds && globalDepartmentList.length > 0
        ? getDepartmentNamesArray(globalDepartmentList, data)
        : [],
  }));
};
